import { isPositiveNumber } from "et3-type-guards";
import ET3Div from "../../../../../../core/et3-div";
import { withLiteObserverAndTheme } from "../../../../../../core/et3-enhanced-render";
import Et3Text from "../../../../../../core/et3-text";
import Et3Margin from "../../../../../../core/et3-ui/ET3Margin";
import ClientPersonalInfo from "../../../../khattabat-clients/ClientPersonalInfo";
import ClientUserName from "../../../../khattabat-clients/ClientUserName";
import CloseOpenConversation from "./CloseOpenConversation";
import SelectMatchConversation from "./SelectConversation";

const Header = withLiteObserverAndTheme<{
  matchID: number;
  matchUserName: string;
  residence: string;
  nationality: string;
  age: number;
  height: number;
  weight: number;
  lastLogin: string;
  marriageType: string;
  isOpenedConversation: boolean;
  matchUnreadMessages: number;
  alkhattabaUUID: string;
  matchUUID: string;
}>((props) => {
  const {
    theme,
    matchID,
    matchUserName,
    residence,
    nationality,
    age,
    height,
    weight,
    lastLogin,
    marriageType,
    isOpenedConversation,
    matchUnreadMessages,
    alkhattabaUUID,
    matchUUID
  } = props;
  const { colors } = theme;
  const haveUnreadMessages = isPositiveNumber(matchUnreadMessages);

  return (
    <ET3Div
      width={1510}
      height={80}
      alignItems={"center"}
      fDirection={"row"}
      style={{ border: `1px solid ${colors.all.gray}` }}
      color={colors.all.whiteBlue}
      justifyContent={"space-between"}
      withShadow={false}
      isExtendable={true}
      isScrollable={false}
      onClick={() => {}}
    >
      <SelectMatchConversation matchID={matchID} />
      <ClientUserName userName={matchUserName} userID={matchID} />
      <ET3Div
        width={900}
        height={80}
        alignItems={"center"}
        fDirection={"row"}
        style={{}}
        color={""}
        justifyContent={"space-between"}
        withShadow={false}
        isExtendable={true}
        isScrollable={false}
        onClick={() => {}}
      >
        <ClientPersonalInfo information={residence} title={"Location"} />
        <ClientPersonalInfo information={nationality} title={"Nationality"} />
        <ClientPersonalInfo information={`${age}`} title={"Age"} />
        <ClientPersonalInfo information={`${height}`} title={"Height"} />
        <ClientPersonalInfo information={`${weight}`} title={"Weight"} />
        <ClientPersonalInfo information={lastLogin} title={"Last Login"} />
        <ClientPersonalInfo information={marriageType} title={""} />
      </ET3Div>
      {!haveUnreadMessages ? null : (
        <Et3Text
          fontFamily={"MEDIUM"}
          fontSize={30}
          text={`${matchUnreadMessages}`}
          isSpan={false}
          color={colors.all.red}
          style={{
            border: `1px solid ${colors.all.red}`,
            padding: 5
          }}
        />
      )}
      <CloseOpenConversation
        matchID={matchID}
        isOpenedConversation={isOpenedConversation}
        alkhattabaUUID={alkhattabaUUID}
        matchUUID={matchUUID}
      />
      <Et3Margin top={0} bottom={0} left={5} right={0} />
    </ET3Div>
  );
});

export default Header;
